/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconBitbucket = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M2.648 3a.64.64 0 0 0-.64.743l2.72 16.51c.07.415.429.722.851.726h13.046a.643.643 0 0 0 .642-.538l2.725-16.692a.64.64 0 0 0-.64-.742L2.648 3ZM14.1 14.93H9.935L8.808 9.045h6.301L14.1 14.931Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconBitbucket.displayName = 'IconBitbucket';
export default IconBitbucket;
